import { subscriptionService } from "../services";
import { EventBus } from "@/helpers";

export const subscription = {
  namespaced: true,
  state: {
    plans: {}
  },
  actions: {
    createCard(context, token) {
      return subscriptionService
        .createCard(token)
        .then(response => {
          console.log(response);
          this.dispatch("auth/getUserProfile");
        })
        .catch(error => {
          console.log("Error createCard: ", error);
          EventBus.$emit("failedCreateCard", error);
        });
    },
    deleteCard() {
      return subscriptionService
        .deleteCard()
        .then(response => {
          console.log(response);
          this.dispatch("auth/getUserProfile");
        })
        .catch(error => {
          console.log("Error deleteCard: ", error);
          EventBus.$emit("failedDeleteCard", error);
        });
    },
    getPlans(context) {
      return subscriptionService
        .getPlans()
        .then(response => {
          console.log(response);
          context.commit("setPlans", {
            response
          });
        })
        .catch(error => {
          console.log("Error getPlans: ", error);
          EventBus.$emit("failedGetPlans", error);
        });
    },
    retrieveSubscription(context) {
      return subscriptionService
        .retrieveSubscription()
        .then(response => {
          console.log(response);
          context.commit(
            "auth/setSubscription",
            {
              response
            },
            {
              root: true
            }
          );
        })
        .catch(error => {
          console.log("Error retrieveSubscription: ", error);
          EventBus.$emit("failedRetrieveSubscription", error);
        });
    },
    createSubscription(context, subscription) {
      return subscriptionService
        .createSubscription(subscription)
        .then(response => {
          console.log(response);
          this.dispatch("auth/getUserProfile");
          if (response.data.error) {
            EventBus.$emit("failedUpdateSubscription");
          } else {
            EventBus.$emit("updatedSubscription");
          }
        })
        .catch(error => {
          console.log("Error createSubscription: ", error);
          EventBus.$emit("failedUpdateSubscription", error);
        });
    },
    updateSubscription(context, subscription) {
      return subscriptionService
        .updateSubscription(subscription)
        .then(response => {
          console.log(response);
          this.dispatch("auth/getUserProfile");
          if (response.data.error) {
            EventBus.$emit("failedUpdateSubscription");
          } else {
            EventBus.$emit("updatedSubscription");
          }
        })
        .catch(error => {
          console.log("Error updateSubscription: ", error);
          EventBus.$emit("failedUpdateSubscription", error);
        });
    },
    cancelSubscription() {
      return subscriptionService
        .cancelSubscription()
        .then(response => {
          console.log(response);
          this.dispatch("auth/getUserProfile");
          if (response.data.error) {
            EventBus.$emit("failedUpdateSubscription");
          } else {
            EventBus.$emit("canceledSubscription");
          }
        })
        .catch(error => {
          console.log("Error cancelSubscription: ", error);
          EventBus.$emit("failedCancelSubscription", error);
        });
    },
    retrieveCoupon(context, coupon) {
      return subscriptionService
        .retrieveCoupon(coupon)
        .then(response => {
          console.log(response);
          EventBus.$emit("retrieveCoupon", JSON.parse(response.data));
        })
        .catch(error => {
          EventBus.$emit("retrieveCoupon", { error: error });
        });
    }
  },
  mutations: {
    setPlans(state, payload) {
      if (payload) {
        state.plans = {};
        var plans = JSON.parse(payload.response.data);
        plans.forEach(plan => {
          state.plans[plan.type] = {
            fee: plan.fee,
            price: plan.price,
            limit: plan.limit
          };
        });
      } else {
        state.plans = {};
      }
    }
  }
};
